import { createFeatureSelector } from '@ngrx/store';

export const loyaltyMessagesState = createFeatureSelector<OLO.State, OLO.State.LoyaltyMessages>('loyaltyMessages');
